module.exports = __webpack_public_path__ + "img/icon-credit-report.4c43a517.svg";